import _ from 'underscore';
import {
  IActivity, IInstrumentation, IInstrumentationSchema, IPerfScenario,
} from './types';

const schema: IInstrumentationSchema = {
  scenario: [
    {
      name: 'perfMarker',
      value: 'PerfMarker',
      setting: {},
      activity: [
        {
          name: 'sendLog',
          value: 'SendLog',
        },
      ],
    },
  ],
};

let perfScenario: IPerfScenario | null = null;

function getScenario(instrumentation: IInstrumentation): IPerfScenario {
  if (_.isEmpty(perfScenario)) {
    instrumentation.addScenario(schema);
    perfScenario = instrumentation.perfMarker.create();
  }

  return perfScenario!;
}

export function createActivity(instrumentation: IInstrumentation): IActivity {
  const scenario = getScenario(instrumentation);

  return scenario.sendLog.create() as IActivity;
}
